<template>
    <div>
        <load v-if="loading_cep" mode="table" message="Buscando endereço(s)." />
        <div v-else class="row">
            <!-- <form-input
				v-model="item.cep"
				@change="searchCEP(item.cep)"
				grid="2"
				label="CEP"
				:required="true"
			/> @input="searchCEP(item.cep)" -->
            <form-input-button
                class="pr-0"
                type="search"
                grid="2"
                v-model="item.cep"
                label="CEP"
                v-mask="'#####-###'"
                btn-class="btn input-group-text border-left-0 p-2 bg-white"
                icon-btn="mdi mdi-magnify mdi-18px"
                placeholder="Buscar CEP"
                @submit="searchCEP(item.cep)"
                :required="true"
                :group="true"
            />
            <!-- Ao informar um CEP, será verificado no json originado do correios, e retornado todos os endereços com o
		CEP pesquisado, em caso de não retornar nada, será verificado nos endereços do CADUnico, esses endereços
		Serão mostrado em uma modal que pedirá para o técnico selecionar o endereço, ao selecionar e confirma
		a modal fecha e os campos abaixo serão preenchidos automaticamente, em caso de mudar o bairro o inverso acontecerá
		ele deverá retornar as informações de logradouro e cep, preenchendo automaticamente   -->
            <form-select
                ref="bairro"
                grid="4"
                v-model="item.localidade_id"
                :itens="localidades"
                :label="$t('Bairro/Localidade')"
                :placeholder="placeholder_bairro"
                :searchtext="placeholder_bairro"
                :loading="loading_localidade"
                :required="true"
                @selected="setLocalidade"
                @search="searchLocalidade"
            />

            <form-select
                ref="logradouro"
                grid="6"
                v-model="item.logradouro_id"
                :label="$t('Logradouro')"
                :itens="logradouros"
                :loading="loading_logradouro"
                :placeholder="placeholder_logradouro"
                :searchtext="placeholder_logradouro"
                @selected="setLogradouro"
                @search="searchLogradouro"
                :required="true"
                :disabled="item.localidade_id ? false : true"
            />

            <form-input
                v-model="item.numero_endereco"
                grid="2"
                label="Número"
                :required="true"
                @change="is_edited = true"
            />
            <form-input
                v-model="item.complemento_endereco"
                grid="4"
                label="Complemento"
                @change="is_edited = true"
            />
            <form-input
                v-model="item.referencia_endereco"
                grid="6"
                label="Ponto de Referência"
                @change="is_edited = true"
            />
            <!-- <div class="col-12 d-flex justify-content-end mb-0" v-if="is_edited">
				<button class="btn btn-warning m-0" @click="restaurar">
					<i class="mdi mdi-backup-restore"></i> Restaurar Endereço
				</button>
			</div> -->
        </div>
        <b-modal
            :hide-footer="true"
            centered
            :no-close-on-backdrop="true"
            size="lg"
            id="modal-endereco-select"
            title="
                                                    			"
        >
            <template #modal-header="{ close }">
                <h5
                    v-html="
                        ceps_count_found > 0
                            ? `Foi encontrado <b>${ceps_count_found}</b> endereço(s) para o CEP <b class='highlightBlueText'>${item.cep}</b>`
                            : ''
                    "
                ></h5>
                <button
                    type="button"
                    aria-label="Close"
                    class="close text-danger"
                    @click="close()"
                >
                    ×
                </button>
            </template>
            <div v-if="ceps_count_found > 0">
                <div class="row px-3" v-if="ceps_count_found > 5">
                    <form-input-group
                        class="px-0"
                        type="search"
                        v-model="search"
                        btn-class="btn input-group-text border-left-0 p-2 bg-white"
                        icon-btn="mdi mdi-magnify mdi-18px"
                        placeholder="Filtrar pelo técnico ou unidade"
                    />
                </div>
                <div
                    style="
                        max-height: 500px;
                        overflow: auto;
                        margin-bottom: 10px;
                    "
                >
                    <table
                        class="b-table table table-striped b-table-stacked-md"
                    >
                        <!-- <thead>
							<tr>
								<th></th>
								<th>Endereço</th>
							</tr>
						</thead> -->
                        <tbody>
                            <tr v-for="cep in filtrarResultados" :key="cep.id">
                                <td>
                                    <input
                                        type="radio"
                                        :id="cep.id"
                                        :value="cep.data"
                                        v-model="cep_selected"
                                    />
                                </td>
                                <td>
                                    <!-- <strong>{{ cep }}</strong> -->
                                    <span
                                        v-if="search"
                                        v-html="
                                            $options.filters.highlight(
                                                cep.value,
                                                search.trim(),
                                                item.cep,
                                                'highlightBlueText'
                                            )
                                        "
                                    ></span>
                                    <span
                                        v-else
                                        v-html="
                                            $options.filters.highlight(
                                                cep.value,
                                                null,
                                                item.cep,
                                                'highlightBlueText'
                                            )
                                        "
                                    ></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 d-flex justify-content-end">
                    <button class="btn btn-danger" @click="cancelar">
                        <i class="mdi mdi-close"></i> Cancelar
                    </button>
                    <button class="btn btn-success" @click="selecionar">
                        <i class="mdi mdi-check-circle"></i> Selecionar
                    </button>
                </div>
            </div>
            <div v-else>
                <h4 class="text-warning text-center">
                    <i class="mdi mdi-24px mdi-alert-decagram-outline"></i> Nada
                    foi encontrado para o CEP {{ item.cep }}.
                </h4>
            </div>
        </b-modal>
        <!-- <EnderecoGoogle /> -->
    </div>
</template>
<script>
import EnderecoGoogle from "./EnderecoGetGoogle.vue";
export default {
    props: ["item"],
    components: { EnderecoGoogle },
    data() {
        return {
            item_temp: [],
            localidades: {},
            logradouros: {},
            ceps: [],
            localidade: {},
            logradouro: {},
            cep_selected: "",
            numero: "",
            complemento: "",
            referencia: "",
            ceps_count_found: 0,
            loading_cep: false,
            loading_localidade: false,
            loading_logradouro: false,
            is_edited: false,
            search: "",
            placeholder_bairro: "Digite o bairro e aguarde",
            placeholder_logradouro: "Selecione um Bairro/Localidade antes",
        };
    },
    watch: {
        // logradouro(n, o) {
        //     this.item.logradouro_id = n;
        // },
        // localidade(n, o) {
        //     this.item.localidade_id = n;
        // },
        item(n, o) {
            this.is_edited = false;
        },
    },
    computed: {
        // sortedRows() {
        // 	return this.tecnicos.filter((row, index) => {
        // 		return index;
        // 	});
        // },
        filtrarResultados() {
            if (this.search != "" && this.search != null) {
                return this.ceps.filter((item) => {
                    const nome = item.value.toLowerCase();
                    const busca = this.search.toLowerCase();

                    return nome.includes(busca);
                });
            } else {
                return this.ceps;
            }
        },
    },
    mounted() {
        if (this.item) {
            // this.localidade = this.item.localidade_id;
            // this.logradouro = this.item.logradouro_id;
            // this.numero = this.item.numero_endereco;
            // this.complemento = this.item.complemento_endereco;
            // this.referencia = this.item.referencia_endereco;
            /*Setar valores dos itens dos selects */

            this.item_temp = JSON.stringify(this.item);
            if (this.item.localidade) {
                this.localidades = [
                    {
                        id: this.item.localidade.id,
                        value: this.item.localidade.value,
                    },
                ];
            }
            if (this.item.logradouros) {
                this.logradouros = this.item.logradouros;

                let verificando_logradouro = this.logradouros.filter((log) => {
                    log.id == this.item.logradouro.id;
                });

                if (verificando_logradouro.length <= 0) {
                    this.logradouros.push({
                        id: this.item.logradouro.id,
                        value: this.item.logradouro.value,
                    });
                }
            }
        }
    },
    methods: {
        restaurar() {
            this.item = JSON.parse(this.item_temp);
            this.is_edited = false;
        },
        selecionar() {
            this.item.cep = this.cep_selected.cep;
            this.item.is_search_cep = true;
            this.item.data_search_cep = this.cep_selected;

            let bairro = this.cep_selected.bairro
                ? this.cep_selected.bairro.bairro
                : this.cep_selected.localidade ? this.cep_selected.localidade.nome_localidade : null;

            let logradouro = this.cep_selected.logradouro
                ? this.cep_selected.logradouro
                : this.cep_selected.nome_logradouro;

            this.item.logradouro_id = logradouro;
            this.item.localidade_id = bairro;
            console.log(bairro);
            if (bairro) {
                this.item.localidade = bairro;
                this.localidades = [
                    {
                        id: bairro,
                        value: bairro,
                    },
                ];
            }

            this.logradouros = [
                {
                    id: logradouro,
                    value: logradouro,
                },
            ];
            this.cancelar();
        },
        setLocalidade(item) {
            // console.log(item);
            // let localidade = this.localidades.filter((e) => {
            // 	return e.id == item;
            // });
            // console.log(localidade);
            // this.item.cep = localidade[0] ? localidade[0].cep : this.item.cep;
            this.is_edited = true;
            this.setSelected(this.item.localidade_id);
        },
        setLogradouro(item) {
            this.is_edited = true;
            let logradouro = this.logradouros.filter((e) => {
                return e.id == item;
            });
            this.item.cep = logradouro[0]
                ? logradouro[0].data.cep
                : this.item.cep;
            this.item.is_search_cep = logradouro[0] ? true : null;
            this.item.data_search_cep = logradouro[0]
                ? logradouro[0].data
                : null;
            // this.setSelected(this.item.localidade_id);
        },
        searchLocalidade: function searchLocalidade(search, load = true) {
            if (search != "") {
                clearTimeout(searchLocalidade.timeout);
                searchLocalidade.timeout = setTimeout(() => {
                    this.loading_localidade = load;
                    this.$refs.bairro.openOptions(false);
                    axios
                        .post("api/dashboard/busca/api/pesquisar_bairro", {
                            bairro: search,
                            cidade: this.item.cidade
                                ? this.item.cidade.nome
                                : this.$store.state.settings.app_cidade,
                        })
                        .then((response) => {
                            if (response.data.length > 0) {
                                this.localidades = response.data;
                                this.$refs.bairro.openOptions(true);
                            } else {
                                this.showMsnCallSuporte(search);
                            }
                            this.loading_localidade = false;
                            this.loading_logradouro = false;
                        })
                        .finally(() => {
                            this.$refs.bairro.closeOptions(false);
                            setTimeout(() => {
                                this.loading_localidade = false;
                                this.$refs.bairro.openOptions(true);
                                this.loading_logradouro = false;
                            }, 3000);
                        });
                }, 1000);
            }
        },
        searchLogradouro: function searchLogradouro(search, load = true) {
            if (search != "") {
                clearTimeout(searchLogradouro.timeout);
                searchLogradouro.timeout = setTimeout(() => {
                    this.loading_localidade = load;
                    this.loading_logradouro = load;
                    this.$refs.logradouro.openOptions(false);
                    let bairro = this.localidades.filter((e) => {
                        return this.item.localidade_id == e.id;
                    });
                    axios
                        .post(
                            "api/dashboard/busca/api/pesquisar_logradouro_name",
                            {
                                logradouro: search,
                                bairro: bairro[0].value,
                                cidade: this.item.cidade
                                    ? this.item.cidade.nome
                                    : this.$store.state.settings.app_cidade,
                            }
                        )
                        .then((response) => {
                            if (response.data.length > 0) {
                                this.logradouros = response.data;
                                this.$refs.logradouro.openOptions(true);
                            } else {
                                this.showMsnCallSuporte(search);
                            }
                        })
                        .finally(() => {
                            this.$refs.logradouro.closeOptions(false);
                            setTimeout(() => {
                                this.loading_localidade = false;
                                this.$refs.logradouro.openOptions(true);
                                this.loading_logradouro = false;
                            }, 3000);
                        });
                }, 1000);
            }
        },
        searchCEP(search, load = true) {
            if (search != "" && search != null) {
                this.loading_cep = load;
                axios
                    .get(
                        `api/dashboard/busca/api/pesquisar_cep?q=${escape(
                            search
                        )}`
                    )
                    .then((response) => {
                        this.ceps = response.data;
                        this.ceps_count_found = response.data.length;
                    })
                    .finally(() => {
                        this.loading_cep = false;
                        this.$bvModal.show("modal-endereco-select");
                        this.is_edited = true;
                    });
            } else {
                swal.fire({
                    icon: "warning",
                    text: "É necessário informar um CEP válido!",
                    showConfirmButton: false,
                });
            }
        },

        setSelected(value) {
            this.loading_logradouro = true;
            if (value) {
                let bairro = this.localidades.filter((e) => {
                    return e.id == value;
                });
                axios
                    .post(`api/dashboard/busca/api/pesquisar_logradouro`, {
                        bairro: bairro[0].value,
                        cidade: this.item.cidade
                            ? this.item.cidade.nome
                            : this.$store.state.settings.app_cidade,
                    })
                    .then((response) => {
                        if (response.data != "nada encontrado") {
                            this.logradouros = response.data;
                        } else {
                            this.logradouros = [];
                        }
                        this.loading_logradouro = false;
                        this.$refs.logradouro.openOptions(true);
                    })
                    .finally(() => {
                        this.loading_logradouro = false;
                    });
            }
        },
        showMsnCallSuporte(search) {
            swal.fire({
                icon: "warning",
                title: `Não encontrado nada para <spam class="text-uppercase text-warning">${search}</spam>`,
                html: `Recomendamos que verifique se foi digitado corretamente.<br><br>Se você tem certeza que está correto, fale com nosso suporte que vamos te ajudar.<br><br><a href="/dashboard/suportes" target="_blank" class="btn btn-primary btn-sm d-flex align-items-center text-uppercase"><i class="mdi mdi-face-agent mdi-24px mr-2"></i> Quero ajuda do suporte</a>`,
                showConfirmButton: false,
            });
        },
        cancelar() {
            // Object.assign(this.$data, this.$options.data.call(this));
            this.$bvModal.hide("modal-endereco-select");
            this.search = null;
        },
    },
};
</script>
<style lang="css">
.highlightText {
    background: yellow;
}

.highlightBlueText {
    background: rgb(163, 213, 255);
}
</style>
